import { ApiFunc, getInstance, getNotAuthInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()
const notAuthInstance = getNotAuthInstance()

export const student: ApiFunc<`${typeof API.STUDENT}{id}`, 'get'> = data =>
  instance.get(`${API.STUDENT}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const studentDelete: ApiFunc<`${typeof API.STUDENT}{id}`, 'delete'> = data =>
  instance.delete(`${API.STUDENT}${'id' in data ? prop('id', data) : data?.name}`)

export const studentList: ApiFunc<`${typeof API.STUDENT}`, 'get'> = data =>
  instance.get(API.STUDENT, {
    params: data,
  })

export const studentFullInfo: ApiFunc<`${typeof API.STUDENT_FULL_INFO}`, 'put'> = data =>
  getInstance().put(API.STUDENT_FULL_INFO, data)

export const studentAchievementRecords: ApiFunc<`${typeof API.STUDENT_ACHIEVEMENT_RECORDS}`, 'get'> = data =>
  instance.get(API.STUDENT_ACHIEVEMENT_RECORDS, {
    params: data,
  })

export const studentAll: ApiFunc<`${typeof API.STUDENT_ALL}`, 'get'> = data =>
  instance.get(API.STUDENT_ALL, {
    params: data,
  })

export const studentGuardList: ApiFunc<`${typeof API.STUDENT_GUARD}`, 'get'> = data =>
  instance.get(API.STUDENT_GUARD, {
    params: data,
  })

export const studentGuardCreate: ApiFunc<`${typeof API.STUDENT_GUARD}`, 'post'> = data =>
  instance.post(API.STUDENT_GUARD, data)

export const studentUsername: ApiFunc<`${typeof API.STUDENT_USERNAME}{username}`, 'get'> = data =>
  instance.get(`${API.STUDENT_USERNAME}${'username' in data ? prop('username', data) : data?.name}`, {
    params: 'username' in data ? dissoc('username', data) : dissoc('name', data),
  })

export const generateTranscript: ApiFunc<`${typeof API.GENERATE_TRANSCRIPT}`, 'post'> = data =>
  instance.post(API.GENERATE_TRANSCRIPT, data)

export const generateProofOfStudy: ApiFunc<`${typeof API.GENERATE_PROOF_OF_STUDY}`, 'post'> = data =>
  instance.post(API.GENERATE_PROOF_OF_STUDY, data)

export const studentPersonalInfo: ApiFunc<`${typeof API.STUDENT_PERSONAL_INFO}`, 'put'> = data =>
  instance.put(API.STUDENT_PERSONAL_INFO, data)

export const studentContactInfo: ApiFunc<`${typeof API.STUDENT_CONTACT_INFO}`, 'put'> = data =>
  instance.put(API.STUDENT_CONTACT_INFO, data)

export const studentAccountInfo: ApiFunc<`${typeof API.STUDENT_ACCOUNT_INFO}{username}`, 'get'> = data =>
  instance.get(`${API.STUDENT_ACCOUNT_INFO}${prop('username', data)}`, {
    params: 'username' in data ? dissoc('username', data) : dissoc('name', data),
  })
export const studentAccountInfoWithDeleted: ApiFunc<
  `${typeof API.STUDENT_ACCOUNT_INFO_WITH_DELETED}{username}`,
  'get'
> = data =>
  instance.get(`${API.STUDENT_ACCOUNT_INFO_WITH_DELETED}${prop('username', data)}`, {
    params: 'username' in data ? dissoc('username', data) : dissoc('name', data),
  })

export const studentStatusUpdate: ApiFunc<`${typeof API.STUDENT_STATUS}`, 'put'> = data =>
  instance.put(API.STUDENT_STATUS, data)

export const studentPublicTranscript: ApiFunc<`${typeof API.STUDENT_PUBLIC_TRANSCRIPT}`, 'get'> = data =>
  notAuthInstance.get(API.STUDENT_PUBLIC_TRANSCRIPT, { params: data })

export const studentPublicStudyProof: ApiFunc<`${typeof API.STUDENT_PUBLIC_STUDY_PROOF}`, 'get'> = data =>
  notAuthInstance.get(API.STUDENT_PUBLIC_STUDY_PROOF, { params: data })

export const studentPublicIdCard: ApiFunc<`${typeof API.STUDENT_PUBLIC_ID_CARD}`, 'get'> = data =>
  notAuthInstance.get(API.STUDENT_PUBLIC_ID_CARD, { params: data })

export const generateStudyProof: ApiFunc<`${typeof API.STUDENT_STUDY_PROOF_GENERATE}`, 'post'> = data =>
  instance.post(API.STUDENT_STUDY_PROOF_GENERATE, data)

export const studentImportCuId: ApiFunc<`${typeof API.STUDENT_IMPORT_CU_ID}`, 'post'> = data =>
  instance.post(API.STUDENT_IMPORT_CU_ID, data as unknown as FormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
export const studentIdCardPrint: ApiFunc<`${typeof API.STUDENT_CARD_PRINT}`, 'post'> = data =>
  instance.post(API.STUDENT_CARD_PRINT, data)

export const studentIdCardAll: ApiFunc<`${typeof API.STUDENT_CARD_ALL}`, 'get'> = data =>
  instance.get(API.STUDENT_CARD_ALL, { params: data })
